export const EDITOR_SUGGESTION_MENU_OPEN_ATTRIBUTE =
  "data-editor-suggestion-menu-open";

export const EDITOR_SUGGESTION_MENU_OPEN_SELECTOR = `[${EDITOR_SUGGESTION_MENU_OPEN_ATTRIBUTE}="true"]`;

export const isEditorSuggestionMenuOpen = () =>
  typeof document !== "undefined" &&
  document.querySelector(EDITOR_SUGGESTION_MENU_OPEN_SELECTOR) !== null;

export const fitFloatingEditorSuggestionMenu = (
  element: HTMLElement,
  padding = 8,
) => {
  const rect = element.getBoundingClientRect();
  const style = element.style;
  const currentLeft = Number.parseFloat(style.left);
  const currentTop = Number.parseFloat(style.top);
  let deltaX = 0;
  let deltaY = 0;

  const maxHeight = Math.max(120, window.innerHeight - padding * 2);
  const visibleHeight = Math.min(rect.height, maxHeight);

  if (rect.left < padding) {
    deltaX = padding - rect.left;
  } else if (rect.right > window.innerWidth - padding) {
    deltaX = window.innerWidth - padding - rect.right;
  }

  if (rect.top < padding) {
    deltaY = padding - rect.top;
  } else if (rect.top + visibleHeight > window.innerHeight - padding) {
    deltaY = window.innerHeight - padding - (rect.top + visibleHeight);
  }

  style.maxHeight = `${maxHeight}px`;
  style.overflowY = "auto";

  if (Number.isFinite(currentLeft) && deltaX !== 0) {
    style.left = `${Math.round(currentLeft + deltaX)}px`;
  }

  if (Number.isFinite(currentTop) && deltaY !== 0) {
    style.top = `${Math.round(currentTop + deltaY)}px`;
  }
};

export const scheduleFitFloatingEditorSuggestionMenu = (
  element: HTMLElement,
  padding?: number,
) => {
  const fit = () => fitFloatingEditorSuggestionMenu(element, padding);
  const animationFrame = window.requestAnimationFrame(fit);
  const timeout = window.setTimeout(fit, 80);

  return () => {
    window.cancelAnimationFrame(animationFrame);
    window.clearTimeout(timeout);
  };
};
